





























import Vue from 'vue';
import CardBrand from '@/components/CardBrand.vue';
import CardContainer from '@/components/CardContainer.vue';
import * as api from '@/api';

export default Vue.extend({
    name: 'UserBrand',
    components: {
        CardBrand,
        CardContainer,
    },
    data() {
        return {
            search: '',
            dataLoading: true,
            brandList: [] as api.BrandCard[],
        };
    },
    async created() {
        this.getUserBrands();
    },
    methods: {
        async loadMore() {
            console.log('loadMore');
        },
        async getUserBrands() {
            this.dataLoading = true;
            const res = await api.getUserBrands({
                search: this.search,
            });
            if (!api.error(res)) {
                this.brandList = res.data;
            }
            this.dataLoading = false;
        },
    },
});
